import React, { MouseEvent, MouseEventHandler } from 'react'
import { iconLocation as IconLocation } from 'client/icons/LocationTypes'
import { Destination } from 'src/types/topDestinations'

import styles from './styles.module.css'
import classNames from 'classnames'

interface ITopDestinationProps {
  readonly item: Destination
  readonly onClick: MouseEventHandler<HTMLButtonElement>
}

export function TopDestination(props: ITopDestinationProps) {
  const { item, onClick } = props
  const { fullName, images, name } = item
  const hasImage = images?.portrait

  const handleClick = (e: MouseEvent<HTMLButtonElement>) => {
    e.stopPropagation()
    onClick(e)
  }

  return (
    <li className={styles.destinationBase} data-testid="top-destination">
      <button className={styles.topDestinationBtn} type="button" onClick={handleClick}>
        <span
          className={classNames({ [styles.iconImage]: hasImage })}
          style={hasImage ? { backgroundImage: `url("${images.portrait}")` } : {}}
        >
          {!hasImage && <IconLocation size={20} />}
        </span>
        <div>
          <h5>{name}</h5>
          <p>{fullName}</p>
        </div>
      </button>
    </li>
  )
}
